import React from "react";
import { useParams } from "react-router-dom";

import {
  useGetEnglishAttemptByIdQuery,
} from "../../slices/englishQuizAttemptApiSlice";

const EnglishQuizResultScreen = () => {
  const { attemptId } = useParams();

  const {
    data: attempt,
    isLoading,
    error,
  } = useGetEnglishAttemptByIdQuery(attemptId);

  if (isLoading) {
    return (
      <div className="p-10 text-center">
        Loading result...
      </div>
    );
  }

  if (error || !attempt) {
    return (
      <div className="p-10 text-center text-red-600">
        Unable to load quiz result.
      </div>
    );
  }

  const passed =
    attempt.result?.toLowerCase() === "pass";

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto">

        <div className="rounded-3xl bg-white shadow-xl p-8">

          {/* Header */}

          <div className="text-center">

            <h1 className="text-3xl font-bold text-gray-800">
              Quiz Completed
            </h1>

            <p
              className={`mt-3 text-2xl font-bold ${
                passed
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              {passed ? "PASS" : "FAIL"}
            </p>

          </div>

          {/* Score */}

          <div className="mt-8 text-center">

            <p className="text-gray-500">
              Your Score
            </p>

            <p className="mt-2 text-4xl font-bold text-blue-600">
              {attempt.obtainedMarks ?? 0} /{" "}
              {attempt.totalMarks ?? 0}
            </p>

            <p className="mt-2 text-2xl font-semibold text-gray-700">
              {attempt.percentage ?? 0}%
            </p>

          </div>

          {/* Statistics */}

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">

            <div className="rounded-xl bg-blue-50 p-4 text-center">
              <p className="text-sm text-gray-500">
                Total Questions
              </p>

              <p className="mt-2 text-2xl font-bold text-blue-600">
                {attempt.totalQuestions ?? 0}
              </p>
            </div>

            <div className="rounded-xl bg-green-50 p-4 text-center">
              <p className="text-sm text-gray-500">
                Correct
              </p>

              <p className="mt-2 text-2xl font-bold text-green-600">
                {attempt.correctAnswers ?? 0}
              </p>
            </div>

            <div className="rounded-xl bg-red-50 p-4 text-center">
              <p className="text-sm text-gray-500">
                Wrong
              </p>

              <p className="mt-2 text-2xl font-bold text-red-600">
                {attempt.wrongAnswers ?? 0}
              </p>
            </div>

            <div className="rounded-xl bg-gray-100 p-4 text-center">
              <p className="text-sm text-gray-500">
                Unanswered
              </p>

              <p className="mt-2 text-2xl font-bold text-gray-600">
                {attempt.unansweredQuestions ?? 0}
              </p>
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default EnglishQuizResultScreen;